import { useCreditFacilityReallocationSummaryRetrieveSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { MoneyTableCellValue } from "gen/model/moneyTableCellValue";
import { useTranslation } from "react-i18next";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { StylesForCellFn } from "shared/components/table/data/DataTableTypes";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

const stylesForCell: StylesForCellFn = (props) => {
  if (
    props.type === "data" &&
    Number(
      (props.row.data?.cells.previous_value.value as MoneyTableCellValue)
        .amount,
    ) > 0
  ) {
    return {
      bg: "gray.50",
    };
  }
};

export const CreditFacilityReallocationSummaryTable = () => {
  const { t } = useTranslation(["creditFacility"]);
  const { fundFamilyId, creditFacilityId, fundFamilyEventId } =
    useRequiredStringParams();
  const { data: tableData } =
    useCreditFacilityReallocationSummaryRetrieveSuspense(
      fundFamilyId,
      creditFacilityId,
      fundFamilyEventId,
    );

  return (
    <TableBox isFullHeight={false} isFullWidth={true}>
      <TableBoxHeader>
        <TableBoxTitle>{t("creditFacility:summary.title")}</TableBoxTitle>
        <DataTableBoxActions />
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable data={tableData} stylesForCell={stylesForCell} />
      </TableBoxBody>
    </TableBox>
  );
};
